module.exports = __webpack_public_path__ + "img/full2-min.79efe3f1.png";